<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../ecs/TableExpand.vue";
var tableDataVue = {};
export default {
  name: "TableElasticComputeCloudResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.ALI.computeInstance.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.ALI.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.ALI.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.computeInstance.instanceName"),
          key: "name"
        },
        {
          title: this.$t("RAM.ALI.computeInstance.instanceID"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.ALI.computeInstance.instanceType"),
          key: "instanceType"
        },
        {
          title: "CPU",
          key: "cpu"
        },
        {
          title: this.$t("RAM.ALI.computeInstance.cache"),
          key: "ram"
        },
        {
          title: this.$t("RAM.ALI.computeInstance.diskStorage"),
          key: "storage"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("instanceId", function(val) {
      tableDataVue.instanceId = val;
    });
    eventBus.$on("instanceName", function(val) {
      tableDataVue.instanceName = val;
    });
    eventBus.$on("publicIp", function(val) {
      tableDataVue.publicIp = val;
    });
    eventBus.$on("accountSearchKey", function(val) {
      tableDataVue.accountSearchKey = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .selectAliyunInstanceByPage({
          companyId: tableDataVue.companyId,
          accountName: tableDataVue.accountName,
          instanceId: tableDataVue.instanceId,
          instanceName: tableDataVue.instanceName,
          publicIp: tableDataVue.publicIp,
          accountIdList: tableDataVue.accountSearchKey,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyId");
      eventBus.$off("accountName");
      eventBus.$off("instanceId");
      eventBus.$off("instanceName");
      eventBus.$off("publicIp");
      eventBus.$off("accountSearchKey");
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/ecs/TableElasticComputeCloudResource.vue